import PlatformSlugEnum from "@/enums/PlatformSlugEnum";

export default {
    [PlatformSlugEnum.ACADEMY] : process.env.VUE_APP_ACADEMY_URL,
    [PlatformSlugEnum.COMPLIANCE] : process.env.VUE_APP_COMPLIANCE_URL,
    [PlatformSlugEnum.DFS] : process.env.VUE_APP_DFS_URL,
};
